import { put, take, call, fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import { reset, SubmissionError } from 'redux-form';

import * as actions from 'actions';
import * as api from 'api';

const convertFormErrors = errors => {
  return errors.reduce((errorsObject, error) => {
    if (error.dataPath) {
      const key = error.dataPath.split('.')[1];
      errorsObject[key] = error.message;
    } else {
      errorsObject['_error'] = error.message;
    }
    return errorsObject;
  }, {});
};

export function* watchForF2FFieldValidate() {
  while(true) { // eslint-disable-line no-constant-condition
    const action = yield take(actions.F2F_FIELD_VALIDATE);

    const { field, value, resolve, reject } = action;
    try {
      yield call(api.f2fFieldValidate, field, value);
      yield call(resolve);
    } catch (error) {
      let formErrors = error;
      if (error.json && error.json.errors) {
        formErrors = convertFormErrors(error.json.errors);
      }
      yield call(reject, formErrors);
    }
  }
}

export function* watchForF2FReferralCreate() {
  while(true) { // eslint-disable-line no-constant-condition
    const action = yield take(actions.F2F_REFERRAL_CREATE);
    const { data, resolve, reject } = action;

    try {
      yield call(api.f2fReferralCreate, data);
      yield call(resolve);
      yield put(reset('referral'));
      yield put(actions.infoShow('success', action.successMessage));
    } catch (error) {
      let formErrors = error;
      if (error.json && error.json.errors) {
        formErrors = convertFormErrors(error.json.errors);
      }

      yield call(reject, new SubmissionError(formErrors));
    }
  }
}

export default function* backgroundSaga(socket, request) {
  yield [
    fork(takeLatest, actions.F2F_STATUS_FETCH, request(api.f2fStatusFetch)),
    fork(takeLatest, actions.F2F_LANGUAGES_FETCH, request(api.f2fLanguagesFetch)),
    fork(takeLatest, actions.F2F_LOCATIONS_FETCH, request(api.f2fLocationsFetch)),
    fork(takeLatest, actions.F2F_SCHOOLS_FETCH, request(api.f2fScoolsFetch)),
    fork(watchForF2FFieldValidate),
    fork(watchForF2FReferralCreate)
  ];
}



/** WEBPACK FOOTER **
 ** ./src/members/state/f2f/sagas.js
 **/